import { createFileRoute } from '@tanstack/react-router'
import { AutomationEditPage } from '@/pages/automations/automation-edit/automation-edit-page'
import { WorkspaceEntitlementGate } from '@/features/workspace-entitlements/ui/workspace-entitlement-gate'
import { WorkspaceEntitlementKey } from '@/graphql/schema'

export const Route = createFileRoute('/automations/$id/edit')({
  component: () => (
    <WorkspaceEntitlementGate feature={WorkspaceEntitlementKey.Automations}>
      <AutomationEditPage />
    </WorkspaceEntitlementGate>
  ),
})
